
import React from 'react';
import { CloseIcon } from '../icons';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: React.ReactNode;
    title: string;
}

export const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children, title }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 w-full h-full flex justify-center items-center bg-black/70 backdrop-blur-sm z-50 p-4">
            <div className="relative bg-white rounded-2xl shadow-lg w-full max-w-[540px] mx-4">
                <div className="absolute top-0 right-0 pt-4 pr-4 z-10">
                     <button onClick={onClose} className="flex p-2.5 justify-center items-center gap-2 rounded-full bg-grayscale-1200 shadow-custom-light">
                       <CloseIcon />
                    </button>
                </div>
                <div className="p-6 pt-8">
                    {children}
                </div>
            </div>
        </div>
    );
};
